import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberEventsPage from "@/pages/member/MemberEventsPage";

export const Route = createFileRoute("/member/events")({
  head: () => pageHead("Member · Events", "AKIVA member · events portal.", "/member/events", true),
  component: MemberEventsPage,
});
